// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__kqLLG","header":"Messages_header__3aBCM"};